import { ConsentUrl } from 'src/Shared/UrlParser';
import * as ErrorLogger from 'src/ConsentManagement/Logging/ErrorLogger';
import { ActiveProfile } from '../Config/ActiveProfile';
import { AssetGuid } from '../Config/Assets';
import { ActiveVendorsModel } from '../Models/ActiveVendorsModel';
import { IabVenderListModel } from '../Models/IabVendorListModel';

const cache: { [name: string]: Promise<any> } = {};

const getAssetPath = (path: string) => `${ActiveProfile.ResourcePath}/${AssetGuid}/${path}`;

const createGetRequest = (url: string): Promise<string> => {
  url = new ConsentUrl(url).toUrlString();

  if (!!cache[url]) return cache[url];

  return (cache[url] = new Promise<string>((resolve, reject) => {
    const req = new XMLHttpRequest();

    req.open('GET', url);

    req.addEventListener('load', () => {
      if (req.status >= 200 && req.status < 400) {
        resolve(req.response);
        return;
      }

      const error = new Error(req?.statusText);
      ErrorLogger.log(`Error fetching asset: ${url}`, error);

      reject(error);
    });

    req.addEventListener('error', () => {
      const error = new Error(req?.statusText);
      ErrorLogger.log(`Error fetching asset: ${url}`, error);

      reject(error);
    });

    req.send();
  }));
};

const GetLanguage = async (url: string): Promise<string> => {
  const requestPath = getAssetPath(`${ActiveProfile.Profile}/languages/${ActiveProfile.Profile}.${url}.json`);

  return createGetRequest(requestPath);
};

const GetIabLanguage = async (url: string): Promise<string> => {
  const fileName = url == 'en' ? `vendor-list` : `purposes-${url}`;
  const requestPath = getAssetPath(`${ActiveProfile.Profile}/iabresource/${fileName}.json`);

  return createGetRequest(requestPath);
};

const GetActiveVendors = async (): Promise<ActiveVendorsModel> => {
  const requestPath = getAssetPath(`shared/active-vendors.json`);

  const response = await createGetRequest(requestPath);
  const activeVendors: ActiveVendorsModel = JSON.parse(response);

  return activeVendors;
};

const GetVendorList = async (): Promise<IabVenderListModel> => {
  const requestPath = getAssetPath(`${ActiveProfile.Profile}/iabresource/vendor-list.json`);

  const response = await createGetRequest(requestPath);
  const vendorList: IabVenderListModel = JSON.parse(response);

  return vendorList;
};

const GetTemplate = async (path: string): Promise<string> => {
  const requestPath = getAssetPath(`templates/${path}.html`);

  return createGetRequest(requestPath);
};

const GetStyle = async (path: string): Promise<string> => {
  const requestPath = getAssetPath(`styles/${path}.css`);
  return createGetRequest(requestPath);
};

export { GetLanguage, GetIabLanguage, GetTemplate, GetStyle, GetActiveVendors, GetVendorList };
